import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";
import { fetchAutenticat, SessioCaducadaError } from "../../utils/auth";
import { tincPermis } from "../../utils/Permisos";
import { useUserContext } from "../../utils/UserContext";
import TeclaEscEnter from "../../utils/Teclaescenter";
import AjudaCataleg from "./AjudaCataleg";
import { BotoAjuda } from "./AjudaModal";

function PackProducte({ producte, onCancel, onActivat, subnav }) {
  const { rolUsuari, empresaSeleccionada } = useUserContext();
  const [packItems, setPackItems] = useState([]);
  const [productesNoPack, setProductesNoPack] = useState([]);
  const [cerca, setCerca] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [composicioActiva, setComposicioActiva] = useState(Number(producte?.PackComposicioActiva) === 1);
  const [ocupat, setOcupat] = useState(false);
  const pucModificar = tincPermis(rolUsuari, "MODIFICAR");
  const [mostraAjuda, setMostraAjuda] = useState(false);

  useEffect(() => {
    if (producte?.idProductes) fetchPackItems(producte.idProductes);
    fetchProductesNoPack();
    setIsEditing(false);
    setCerca("");
    setComposicioActiva(Number(producte?.PackComposicioActiva) === 1);
  }, [producte]);

  const fetchPackItems = async (idProductePare) => {
    try {
      const response = await fetch(`${API_URL}/Packproducte.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idProductes: idProductePare }),
      });
      const data = await response.json();
      setPackItems(data.success ? data.packItems || [] : []);
    } catch (error) {
      console.error("Error al carregar ítems del pack:", error);
    }
  };

  const fetchProductesNoPack = async () => {
    try {
      const response = await fetch(`${API_URL}/Productesnopack.php`);
      const data = await response.json();
      setProductesNoPack(data.success ? data.productes || [] : []);
    } catch (error) {
      console.error("Error al carregar productes no pack:", error);
    }
  };

  const handleAddRow = () => {
    setPackItems((prev) => [
      ...prev,
      {
        idProducteFill: null,
        idProductePare: producte.idProductes,
        Quantitat: 1,
        Marca: "",
        Model: "",
        UnitatMesura: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    setPackItems((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      if (field === "idProducteFill") {
        const trobat = productesNoPack.find((p) => Number(p.idProductes) === Number(value));
        updated[index].Marca = trobat?.Marca || "";
        updated[index].Model = trobat?.Model || "";
        updated[index].UnitatMesura = trobat?.UnitatMesura || "";
      }
      return updated;
    });
  };

  const handleDelete = (index) => {
    setPackItems((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    const itemsNets = packItems.filter((item) => item.Quantitat && item.idProducteFill);
    if (itemsNets.length === 0) {
      alert("Afegeix almenys un producte amb quantitat.");
      return;
    }
    try {
      const response = await fetch(`${API_URL}/Guardarpackproducte.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idProductePare: producte.idProductes,
          packItems: itemsNets,
        }),
      });
      const result = await response.json();
      if (result.success) {
        setIsEditing(false);
        fetchPackItems(producte.idProductes);
      } else {
        alert(`Error en guardar les dades: ${result.message}`);
      }
    } catch (error) {
      console.error("Error en guardar dades del pack:", error);
      alert("Error al processar la sol·licitud de guardar les dades.");
    }
  };

  const activarComposicio = async () => {
    if (!window.confirm("Vols activar la composició? L'estoc i les reserves del pack passaran als components, a totes les empreses. Després ja no es podrà modificar.")) {
      return;
    }
    setOcupat(true);
    try {
      const resposta = await fetchAutenticat(`${API_URL}/Activarcomposiciopack.php`, {
        method: "POST",
        body: JSON.stringify({
          idProductes: producte.idProductes,
          idEmpresa: empresaSeleccionada?.IdEmpresa || null,
        }),
      });
      const resultat = await resposta.json();
      if (!resultat.success) {
        alert(resultat.message || "No s'ha pogut activar la composició.");
        return;
      }
      setComposicioActiva(true);
      setIsEditing(false);
      onActivat?.();
    } catch (error) {
      if (error instanceof SessioCaducadaError) return;
      alert("No s'ha pogut activar la composició.");
    } finally {
      setOcupat(false);
    }
  };

  TeclaEscEnter(onCancel, isEditing ? handleSubmit : null);

  const lower = (cerca || "").toLowerCase();
  const productesFiltrats = (productesNoPack || []).filter((p) => {
    if (!lower) return true;
    return `${p.Marca || ""} ${p.Model || ""} ${p.RefProducte || ""}`.toLowerCase().includes(lower);
  });

  return (
    <div className="dv2-entity">
      {mostraAjuda && <AjudaCataleg pestanya="pack" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className="dv2-pageHeader-icon" aria-hidden="true">
            📦
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">Pack</h1>
            <p className="dv2-pageHeader-subtitle">
              {[producte?.Marca, producte?.Model].filter(Boolean).join(" ") || "Composició del pack"}
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funciona el Pack" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {pucModificar && !isEditing && !composicioActiva && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={() => setIsEditing(true)}>
              Editar
            </button>
          )}
          {pucModificar && !isEditing && !composicioActiva && packItems.length > 0 && (
            <button type="button" className="dv2-btn" disabled={ocupat} onClick={activarComposicio}>
              Activar composició
            </button>
          )}
          {isEditing && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar
            </button>
          )}
        </div>
      </div>
      {subnav}

      <div className="dv2-entity-body">
      <section className="dv2-card">
        <div className="dv2-card-head">
          <span className="dv2-card-num">1</span>
          <h2 className="dv2-card-title">Composició</h2>
        </div>
        {composicioActiva && (
          <p className="dv2-hint">La composició està activa. L'estoc i les reserves es compten pels components.</p>
        )}
        {!isEditing ? (
          packItems.length === 0 ? (
            <p className="dv2-empty">Aquest pack encara no té productes. Entra a editar per afegir-ne.</p>
          ) : (
            <div className="dv2-specList">
              {packItems.map((item, index) => (
                <div key={index} className="dv2-spec">
                  <span className="dv2-spec-name">
                    {item.Quantitat} {item.UnitatMesura || "ut"}
                  </span>
                  <span className="dv2-spec-value">
                    {[item.Marca, item.Model].filter(Boolean).join(" ") || "—"}
                  </span>
                </div>
              ))}
            </div>
          )
        ) : (
          <>
            <div className="dv2-filter" style={{ marginBottom: 12, maxWidth: 360 }}>
              <span className="dv2-filter-label">Cerca productes del desplegable</span>
              <input
                type="text"
                className="dv2-input"
                placeholder="Marca o model…"
                value={cerca}
                onChange={(e) => setCerca(e.target.value)}
              />
            </div>
            {packItems.map((item, index) => {
              const opcions = productesFiltrats.slice();
              if (
                item.idProducteFill &&
                !opcions.some((p) => Number(p.idProductes) === Number(item.idProducteFill))
              ) {
                opcions.unshift({
                  idProductes: item.idProducteFill,
                  Marca: item.Marca,
                  Model: item.Model,
                });
              }
              return (
                <div key={index} className="dv2-editorRow" style={{ gridTemplateColumns: "110px 1fr 40px" }}>
                  <label className="dv2-field">
                    <span className="dv2-label">Quantitat</span>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      className="dv2-input"
                      value={item.Quantitat}
                      onChange={(e) => handleChange(index, "Quantitat", e.target.value)}
                    />
                  </label>
                  <label className="dv2-field">
                    <span className="dv2-label">
                      Producte {item.UnitatMesura ? `(${item.UnitatMesura})` : ""}
                    </span>
                    <select
                      className="dv2-select"
                      value={item.idProducteFill || ""}
                      onChange={(e) => handleChange(index, "idProducteFill", e.target.value ? Number(e.target.value) : null)}
                    >
                      <option value="">Selecciona un producte</option>
                      {opcions.map((p) => (
                        <option key={p.idProductes} value={p.idProductes}>
                          {[p.Marca, p.Model].filter(Boolean).join(" ")}
                        </option>
                      ))}
                    </select>
                  </label>
                  <button type="button" className="dv2-btn" title="Esborrar línia" onClick={() => handleDelete(index)}>
                    ✕
                  </button>
                </div>
              );
            })}
            <div style={{ marginTop: 12 }}>
              <button type="button" className="dv2-btn" onClick={handleAddRow}>
                Afegir producte
              </button>
            </div>
          </>
        )}
      </section>
      </div>

      {isEditing && (
        <div className="dv2-entity-dock">
          <div className="dv2-footerActions">
            <button type="button" className="dv2-btn" onClick={() => setIsEditing(false)}>
              Cancel·lar
            </button>
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar pack
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PackProducte;
